import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CacheService } from './cache.service';

@Injectable()
export class CacheInterceptor implements HttpInterceptor {
  constructor(private readonly cache: CacheService) {}

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.cache.isCacheable(request)) {
      const cachedResponse = this.cache.getCache(request);
      if (cachedResponse) {
        return of(cachedResponse);
      }
      return next.handle(request).pipe(
        tap((response) => {
          if (response instanceof HttpResponse) {
            this.cache.putCache(request, response);
          }
        })
      );
    }
    return next.handle(request);
  }
}
